import React, { Component } from "react";
import {
  Paper,
  RaisedButton,
  Divider,
  Subheader,
  FlatButton,
} from "material-ui";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default class ClientSyncIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: "",
      activePage: 1,
      filterMessage: "",
      filterButtons: [
        { label: "Clear", field: "" },
        { label: "Salutation", field: "salutation__c" },
        { label: "Name", field: "name" },
        { label: "Address Street", field: "billingstreet" },
        { label: "Address City", field: "billingcity" },
        { label: "Address State", field: "billingstate" },
        { label: "Address ZIP Code", field: "billingpostalcode" },
        // {label: 'Address Country', field: 'billingcountry'},
        { label: "Phone", field: "phone" },
        { label: "Primary Email", field: "primary_email__c" },
      ],
      styles: {
        textButton: {
          background: "none",
          border: "none",
          margin: 0,
          padding: 0,
          cursor: "pointer",
          color: "blue",
        },
      },
    };

    this.linkFormatter = this.linkFormatter.bind(this);
    this.filterClients = this.filterClients.bind(this);
  }

  componentWillMount() {
    this.props.authFetchWorkorders(
      "clients?compareResults=true",
      this.props.token.jwt,
    );
  }

  filterClients(f) {
    this.props.authFetchWorkorders(
      `clients?compareResults=true&field=${f.field}`,
      this.props.token.jwt,
    );
    this.setState({ filterMessage: f.field ? f.label : "" });
  }

  renderButton(f) {
    return (
      <FlatButton
        key={f.label}
        label={f.label}
        backgroundColor="#E0E0E0"
        hoverColor="#BDBDBD"
        style={{ margin: "0.5em" }}
        onClick={this.filterClients.bind(this, f)}
      />
    );
  }

  linkFormatter(cell, row) {
    return (
      <button
        style={this.state.styles.textButton}
        onClick={this.props.performRoute.bind(
          this,
          `/job/salesForceClients/ClientEditor/${row._id}?compare=1`,
        )}
      >
        {cell}
      </button>
    );
  }

  render() {
    let filter = { type: "TextFilter", delay: 500 };

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em" }}
        >
          <center>
            <h3>Out of Sync Clients</h3>
          </center>
          <Divider />
          <div>
            <Subheader>Filters</Subheader>
            {this.state.filterButtons.map((f) => this.renderButton(f))}
            {this.state.filterMessage !== "" && (
              <center>
                <h4>
                  Showing results for: {this.state.filterMessage} (
                  {this.props.workOrders.length})
                </h4>
              </center>
            )}
          </div>
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn
              dataField="uid__c"
              filter={filter}
              dataSort
              isKey
              width="125"
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              dataSort
              filter={filter}
              dataFormat={this.linkFormatter}
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="primary_email__c"
              dataSort
              filter={filter}
            >
              Email
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="phone"
              dataSort
              filter={filter}
              width="200"
            >
              Phone
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/clients/ClientSyncIndex.js